const PrepProcessSingle = () => import("@/pages/lab/prepprocess/PrepProcessSingle");
const PrepProcessIndex = () => import("@/pages/lab/prepprocess/PrepProcessIndex");
const PrepProcessDetail = () => import("@/pages/lab/prepprocess/PrepProcessDetail");
const PrepProcessAdd = () => import("@/pages/lab/prepprocess/PrepProcessAdd");
const PrepProcessEdit = () => import("@/pages/lab/prepprocess/PrepProcessEdit");
const PrepProcessSort = () => import("@/pages/lab/prepprocess/PrepProcessSort");
const PrepTaskAdd = () => import("@/pages/lab/preptask/PrepTaskAdd");
export class PrepProcessRoutes {
  constructor() {
    this.route_root = "prep-processes/";
    this.type_single = "Prep Process";
    this.type_plural = "Prep Processes";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          }
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: `List ${this.type_plural}`,
            component: PrepProcessIndex,
            meta: { requiresAuth: true }
          },
          {
            path: "add",
            name: `New ${this.type_single}`,
            component: PrepProcessAdd,
            meta: { requiresAuth: true }
          },
          {
            path: ":prep_process_id",
            component: PrepProcessSingle,
            children: [
              {
                path: "",
                name: `View ${this.type_single}`,
                component: PrepProcessDetail,
                meta: { requiresAuth: true }
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: PrepProcessEdit,
                meta: { requiresAuth: true }
              },
              {
                path: "sort",
                name: `Sort ${this.type_single}`,
                component: PrepProcessSort,
                meta: { requiresAuth: true }
              },
              {
                path: "task/add",
                name: `Add ${this.type_single} Task`,
                component: PrepTaskAdd,
                meta: { requiresAuth: true }
              }
            ]
          }
        ]
      }
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
